var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.98 0.734375L12.3582 1.7807V17.0475L18.4016 15.1932C19.9338 14.7231 20.98 13.3068 20.98 11.7026V0.734375Z",
    fill: "url(#paint0_linear_4946_8676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87538 2.79775C2.15674 3.00199 0.862305 4.46072 0.862305 6.19326V25.3226L7.15346 23.4704C8.70561 23.0134 9.77149 21.5874 9.77149 19.9678V2.09707L3.87538 2.79775Z",
    fill: "url(#paint1_linear_4946_8676)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2744 34.266L22.8963 33.2196V17.9529L16.8528 19.8071C15.3206 20.2772 14.2744 21.6935 14.2744 23.2978V34.266Z",
    fill: "url(#paint2_linear_4946_8676)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2744 34.266L22.8963 33.2196V17.9529L16.8528 19.8071C15.3206 20.2772 14.2744 21.6935 14.2744 23.2978V34.266Z",
    fill: "url(#paint3_linear_4946_8676)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2744 34.266L22.8963 33.2196V17.9529L16.8528 19.8071C15.3206 20.2772 14.2744 21.6935 14.2744 23.2978V34.266Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.379 32.2026C33.0976 31.9984 34.3921 30.5396 34.3921 28.8071V9.67773L28.1008 11.53C26.5487 11.987 25.4828 13.413 25.4828 15.0326V32.9033L31.379 32.2026Z",
    fill: "url(#paint4_linear_4946_8676)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.379 32.2026C33.0976 31.9984 34.3921 30.5396 34.3921 28.8071V9.67773L28.1008 11.53C26.5487 11.987 25.4828 13.413 25.4828 15.0326V32.9033L31.379 32.2026Z",
    fill: "url(#paint5_linear_4946_8676)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.379 32.2026C33.0976 31.9984 34.3921 30.5396 34.3921 28.8071V9.67773L28.1008 11.53C26.5487 11.987 25.4828 13.413 25.4828 15.0326V32.9033L31.379 32.2026Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4946_8676",
    x1: 0.862304,
    y1: 21.8189,
    x2: 52.9004,
    y2: -8.13363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4946_8676",
    x1: 0.862304,
    y1: 21.8189,
    x2: 52.9004,
    y2: -8.13363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4946_8676",
    x1: 7.67136,
    y1: 34.2545,
    x2: 82.4694,
    y2: 4.76806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4946_8676",
    x1: 34.3921,
    y1: 13.1815,
    x2: -17.646,
    y2: 43.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4946_8676",
    x1: 7.67136,
    y1: 34.2545,
    x2: 82.4694,
    y2: 4.76806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4946_8676",
    x1: 34.3921,
    y1: 13.1815,
    x2: -17.646,
    y2: 43.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvxLogo);
export default __webpack_public_path__ + "static/media/pvx-logo.4fe2c207cf45cbb460913402780ca992.svg";
export { ForwardRef as ReactComponent };